import type { ReactNode, JSX } from 'react';

import styles from './ConfigSection.module.scss';

interface Props {
  title: string;
  description?: string;
  children: ReactNode;
  footer?: ReactNode;
}

/**
 * OS-1388 — contenedor reutilizable para subsecciones de Configuración del tenant.
 */
export function ConfigSection({ title, description, children, footer }: Props): JSX.Element {
  return (
    <section className={styles.section}>
      <header className={styles.header}>
        <h3 className={styles.title}>{title}</h3>
        {description ? <p className={styles.description}>{description}</p> : null}
      </header>
      <div className={styles.body}>{children}</div>
      {footer ? <div className={styles.footer}>{footer}</div> : null}
    </section>
  );
}
